import { defineComponent as t, openBlock as o, createBlock as c, unref as n, mergeProps as p, withCtx as s, createElementVNode as e } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceArrowFilled",
  __name: "IconReassuranceArrowFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const r = l;
    return (i, a) => (o(), c(n(d), p(r, { "view-box": "0 0 48 48" }), {
      default: s(() => [...a[0] || (a[0] = [
        e("g", {
          "fill-rule": "evenodd",
          "clip-path": "url(#3c80e757-6178-427c-8864-974664564c6ba)",
          "clip-rule": "evenodd"
        }, [
          e("path", { d: "m19.34 11 21 8.75v.01A1.89 1.89 0 0 1 40.76 23l-18.1 13.75a1.92 1.92 0 0 1-1.645.321 1.88 1.88 0 0 1-1.375-1.58L19.06 31l-8.38 2.8a1.9 1.9 0 0 1-2.47-1.56L6.52 19a1.86 1.86 0 0 1 1.174-1.935A1.9 1.9 0 0 1 8.51 16.94l8.8.55L16.74 13a1.89 1.89 0 0 1 2.6-2m10.17 8.41c-.11-.75-.5-1.32-.86-1.27-.37.05-.58.71-.47 1.46s.49 1.32.86 1.27.58-.71.47-1.46m-3.32 2.11c0-.76-.3-1.38-.67-1.38v.03c-.37 0-.67.59-.67 1.35s.3 1.38.67 1.38.67-.62.67-1.38m1.28 5.37a7 7 0 0 0 2.26-.4l-.04.04A.28.28 0 0 0 29.55 26a8.1 8.1 0 0 1-4.1-.33 7.7 7.7 0 0 1-1.81-1 11.3 11.3 0 0 1-1.59-1.35.27.27 0 0 0-.39 0 .28.28 0 0 0-.05.32 6 6 0 0 0 2.49 2.41 8.5 8.5 0 0 0 1.07.47 7.2 7.2 0 0 0 2.3.37" }),
          e("path", { d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91M23.26 37.58l18.1-13.79.03.06a2.89 2.89 0 0 0-.64-5l-21-8.77a2.89 2.89 0 0 0-4 3l.42 3.29-7.6-.48a2.89 2.89 0 0 0-3.05 3.25l1.71 13.23A2.89 2.89 0 0 0 11 34.75l7.22-2.33.42 3.28A2.88 2.88 0 0 0 20.4 38a2.8 2.8 0 0 0 1.11.15 2.3 2.3 0 0 0 .37 0 2.8 2.8 0 0 0 1.38-.57" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "3c80e757-6178-427c-8864-974664564c6ba" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
